import React from 'react';
export function Header() {
  return <header className="w-full border-b border-crown-border bg-crown-bg" data-id="element-77">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-78">
        <div className="flex items-center" data-id="element-79">
          <h1 className="text-2xl font-bold text-crown-text" data-id="element-80">
            Crown<span className="text-crown-red" data-id="element-81">Control</span>™
          </h1>
        </div>
      </div>
    </header>;
}